import 'core-js/stable/number';
import 'core-js/stable/string/repeat';
import Swiper from 'swiper/bundle';

const videoSlider = () => {
  new Swiper('#swiper-video', {
    slidesPerView: 3,
    spaceBetween: 15,
    loop: true,
    centeredSlides: true,
    slideToClickedSlide:true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    navigation: {
    nextEl: ".right",
    prevEl: ".left",
    },
  });
};

export default videoSlider;
